module.exports = "<h4 id=\"mdl\">MDL</h4>\n<p><strong>Проект:</strong> Криптовалютный проект на смарт контрактах</p>\n<p><strong>Описание:</strong> Экосистема для связи талантов (музыкантов, моделей, тату мастеров и т.д.) с заказчиками.</p>\n<p><strong>Языки:</strong>​ Ruby</p>\n<p><strong>Позиция:</strong> Developer</p>\n<p><strong>Ответственность:​</strong></p>\n<ul>\n<li>MvP</li>\n<li>Authentication</li>\n<li>Api</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/mdl_ru.md
// module id = hLhp
// module chunks = 1